import { forwardRef } from 'react';
import MegaMenu from './MegaMenu';

/**
 * The site menu in a wrapper that takes a ref. It used to load the menu
 * lazily; pages that use it are prerendered, and a lazy part inside a page
 * hydrates in a later pass, where an update from above makes React replace
 * its HTML (see src/lib/lazyComponent.ts). So the menu is imported directly.
 */
const LazyMegaMenu = forwardRef<HTMLDivElement>((_, ref) => {
  return (
    <div ref={ref}>
      <MegaMenu />
    </div>
  );
});

LazyMegaMenu.displayName = 'LazyMegaMenu';

export default LazyMegaMenu;
